import { DateTime } from "luxon";

function isIsoDateString(rawDate) {
  if (typeof rawDate !== "string") {
    return false;
  }

  const trimmed = rawDate.trim();
  if (!trimmed) {
    return false;
  }

  return DateTime.fromISO(trimmed).isValid;
}

function normalizeAmount(rawAmount) {
  if (rawAmount === null || rawAmount === undefined || rawAmount === "") {
    return null;
  }

  if (typeof rawAmount === "number") {
    return Number.isFinite(rawAmount) ? rawAmount : null;
  }

  if (typeof rawAmount !== "string") {
    return null;
  }

  const trimmed = rawAmount.trim();
  if (!trimmed) {
    return null;
  }

  const isNegativeByParentheses =
    trimmed.startsWith("(") && trimmed.endsWith(")");
  const cleaned = trimmed.replace(/[,$()]/g, "").replace(/\s+/g, "");
  const parsed = Number.parseFloat(cleaned);

  if (!Number.isFinite(parsed)) {
    return null;
  }

  return isNegativeByParentheses ? -Math.abs(parsed) : parsed;
}

function normalizeDescription(rawDescription) {
  if (rawDescription === null || rawDescription === undefined) {
    return "";
  }

  return String(rawDescription).trim();
}

function normalizeDetailKey(key) {
  return String(key).trim().toLowerCase().replace(/\s+/g, "_");
}

function normalizeDetails(rawDetails) {
  if (!rawDetails || typeof rawDetails !== "object") {
    return undefined;
  }

  const entries = Object.entries(rawDetails)
    .filter(([, value]) => {
      return (
        value !== null && value !== undefined && String(value).trim() !== ""
      );
    })
    .map(([key, value]) => [normalizeDetailKey(key), value]);

  return entries.length ? Object.fromEntries(entries) : undefined;
}

export function validateAndNormalizeTransactions(candidateTransactions = []) {
  const transactions = [];
  const errors = [];

  candidateTransactions.forEach((candidate, index) => {
    const rowNumber = candidate?.rowNumber ?? index + 1;

    const candidateDate = candidate?.date;
    const normalizedAmount = normalizeAmount(candidate?.amount);
    const normalizedDescription = normalizeDescription(candidate?.description);
    const normalizedDetails = normalizeDetails(candidate?.details);

    const rowErrors = [];

    if (!isIsoDateString(candidateDate)) {
      rowErrors.push("Invalid date");
    }

    if (normalizedAmount === null) {
      rowErrors.push("Invalid amount");
    }

    if (!normalizedDescription) {
      rowErrors.push("Missing description");
    }

    if (rowErrors.length > 0) {
      errors.push({
        rowNumber,
        message: rowErrors.join(", "),
      });
      return;
    }

    transactions.push({
      date: String(candidateDate).trim(),
      amount: normalizedAmount,
      description: normalizedDescription,
      details: normalizedDetails,
    });
  });

  return { transactions, errors };
}
